<script setup>
import { NOTIFICATION_TYPES } from '@/constants/connections'
import { useNotificationsStore } from '@/stores/NotificationsStore'
import { useRouter } from 'vue-router'

const props = defineProps({
  type: { type: String, required: true },
  id: { type: Number, required: true },
})

const notificationsStore = useNotificationsStore()

const router = useRouter()

const handleClick = () => {
  notificationsStore.markAsRead(props.id)
  router.push(NOTIFICATION_TYPES[props.type].link)
}
</script>
<template>
  <button class="text-xs text-tint-1 hover:underline cursor-pointer self-start" @click="handleClick">
    {{ NOTIFICATION_TYPES[type].buttonLabel }}
  </button>
</template>